import { List } from 'immutable';
import { createSelector } from 'reselect';
import { State } from 'flow/types/State';
import { TypedMap } from 'flow/types/TypedMap';
import { VideoChatMessage } from 'flow/types/VideoChat';

export const selectVideoChatMessages = (
    state: State,
): List<TypedMap<VideoChatMessage>> => state.videoChat.get('messages');

/** Only externally-originated messages. Used by the merged in-meeting chat
 *  panel for internal users — the chat-service feed is canonical for internal
 *  messages, so the side-channel echoes of internal dual-writes are dropped.
 *
 *  Memoized on the messages list: `.filter()` returns a fresh List each call,
 *  so without memoization useAppSelector would fail reference-equality and
 *  re-render MessageList on every unrelated store dispatch. */
export const selectVideoChatExternalMessages = createSelector(
    selectVideoChatMessages,
    (messages): List<TypedMap<VideoChatMessage>> =>
        messages.filter((m) => m.get('isExternal')) as List<
            TypedMap<VideoChatMessage>
        >,
);

export const selectVideoChatConnected = (state: State): boolean =>
    state.videoChat.get('connected');

export const selectVideoChatReconnecting = (state: State): boolean =>
    state.videoChat.get('reconnecting');

export const selectVideoChatError = (state: State): string | null =>
    state.videoChat.get('errorMessage');

// Guest-relay messages received while the chat panel was closed (VID-433).
export const selectVideoChatUnreadExternalCount = (state: State): number =>
    state.videoChat.get('unreadExternalCount', 0);
